// extracted by mini-css-extract-plugin
export default {"inputRow":"bGjOS78XTIJ8s6pfGnfw"};